import { cn } from 'lib/utils';
import React, { useState } from 'react';

interface CustomInputPrimaryProps {
    placeholder: string;
    value?: string;
    onChange?: (value: string) => void;
}

const CustomInputPrimary = ({ placeholder, value, onChange }: CustomInputPrimaryProps) => {
    const [inputValue, setInputValue] = useState(value || '');

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setInputValue(event.target.value);
        onChange && onChange(event.target.value);
    };

    return (
        <div className="w-full relative select-none">
            <input
                type="text"
                value={inputValue}
                onChange={handleChange}
                placeholder={placeholder}
                className={cn(
                    'w-full text-txt-40 font-medium h-[40px] md:h-[49px] rounded-xl bg-dark-05 flex items-center justify-between px-3 md:px-5 text-sm md:text-base',
                    'focus:outline-none focus:ring-1 focus:ring-brend',
                )}
            />
        </div>
    );
};

export default CustomInputPrimary;
